import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IService } from "../serviceModel";

export const getAllService = createAsyncThunk(
  "Services/FindAllServices",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/FindAllServices`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createService = createAsyncThunk(
  "Services/InsertServices",
  async (ServiceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/InsertServices`,
        ServiceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateService = createAsyncThunk(
  "Services/UpdateServices",
  async (ServiceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/UpdateServices`,
        ServiceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteService = createAsyncThunk(
  "Services/DeleteServices",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/DeleteServices`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getServiceByID = createAsyncThunk(
  "Services/FindByIDServices",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/FindByIDServices`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServiceName: result?.ServiceName,
        ServiceURL: result?.ServiceURL,
        ShortDescription: result?.ShortDescription || "",
        LongDescription: result?.LongDescription || "",
        AboutService: result?.AboutService || "",
        ServiceDetails: result?.ServiceDetails || "",
        MetaTitle: result?.MetaTitle,
        MetaKeywords: result?.MetaKeywords,
        MetaDescription: result?.MetaDescription,
        MainServiceImage: result.MainServiceImage,
        BannerImage: result.BannerImage,
        ContentImage: result.ContentImage,
        SequenceNo: result.SequenceNo,
        ServicesImageDetails: result.ServicesImageDetails || [],
        IsActive: result.IsActive ? 1 : 2,
      } as IService;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveService = createAsyncThunk(
  "Services/FindAllActiveServices",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Services/FindAllActiveServices`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveService = createAsyncThunk(
  "Services/ActiveInActivServices",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/ActiveInActivServices`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const ServiceImageUpload = createAsyncThunk(
  "Services/ServicesImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/ServicesImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Service Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const InsertUpdateServiceImage = createAsyncThunk(
  "Services/ServicesDetailsImageUpdate",
  async (imagedata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/ServicesDetailsImageUpdate`,
        imagedata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Saving Services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const DeleteServiceImage = createAsyncThunk(
  "Services/DeleteServicesImageDetails",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Services/DeleteServicesImageDetails`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Delete Services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
